/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { getHygraphCosmosPageData } from "@cosmos/hygraph-data";
import { CosmosPageResearchMetadataQuery, Locale } from "@cosmos/hygraph-schema";
import { getHygraphLocale, getSlugParam } from "@cosmos/next-common";
import { isError } from "@epic-mw/error-types";
import { Metadata } from "next";

import { CosmosPageMetadata } from "../common";

export const getPageMetadata = async (
	locale: string = Locale.En,
	slug: string,
	previewParam?: string | string[],
	endpoint?: string,
): Promise<CosmosPageResearchMetadataQuery> => {
	if (!slug) {
		throw new Error("Missing slug");
	}
	const preview = previewParam && typeof previewParam === "string" ? previewParam : undefined;

	const pageData = await getHygraphCosmosPageData(
		"CosmosPageResearchMetadata",
		{
			locale: [locale, Locale.En] as Locale[],
			slug,
		},
		preview,
		endpoint,
	);

	return pageData;
};

export async function cosmosPageResearchMetadata({
	slug: rootSlug = "",
	params,
	searchParams,
	hygraphLocales,
	getAppMetadata,
	hygraphEndpoint,
}: CosmosPageMetadata): Promise<Metadata> {
	const slugParam = getSlugParam(params);
	const slug = `${rootSlug}${slugParam}`;
	const locale = params.lang;
	let pageData: CosmosPageResearchMetadataQuery = {};
	try {
		pageData = await getPageMetadata(
			getHygraphLocale(hygraphLocales, locale),
			slug,
			searchParams.preview,
			hygraphEndpoint,
		);
	} catch (e) {
		console.error("Failed to get cosmosPageResearchMetadata()", { error: isError(e) && e.message });
	}
	const metaTags = pageData.cosmosPageResearch?.metaTags || {};

	return getAppMetadata(metaTags, slug, locale);
}
